import * as Types from "../schemaTypes.generated";

import gql from "graphql-tag";
import * as Urql from "urql";
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type GetBanksQueryVariables = Types.Exact<{ [key: string]: never }>;

export type GetBanksQuery = { __typename?: "query_root" } & {
  banks: Array<
    { __typename?: "banks" } & Pick<
      Types.Banks,
      | "notes"
      | "id"
      | "name"
      | "address"
      | "regulator"
      | "ownership"
      | "created_at"
      | "risk_rating_sp_date"
      | "risk_rating_short_sp"
      | "risk_rating_long_sp"
      | "risk_outlook_sp"
      | "risk_rating_fitch_date"
      | "risk_rating_short_fitch"
      | "risk_rating_long_fitch"
      | "risk_outlook_fitch"
      | "risk_rating_moodys_date"
      | "risk_rating_long_moodys"
      | "risk_outlook_moodys"
      | "risk_5y_cds_spread"
      | "risk_total_equity"
      | "risk_cet_capital_ratio"
      | "risk_leverage_ratio"
      | "risk_liquidity_coverage_ratio"
      | "risk_share_movement"
      | "risk_market_cap"
      | "risk_base_currency"
    > & {
        image?: Types.Maybe<
          { __typename?: "uploads" } & Pick<
            Types.Uploads,
            "s3_key" | "s3_level" | "public_url"
          >
        >;
        bank_factsheets: Array<
          { __typename?: "bank_factsheets" } & Pick<
            Types.Bank_Factsheets,
            "factsheetDate"
          > & {
              upload: { __typename?: "uploads" } & Pick<
                Types.Uploads,
                "reviewed" | "description" | "created_at" | "public_url" | "id"
              >;
            }
        >;
        organisations: Array<
          { __typename?: "organisation_banks" } & {
            organisation: { __typename?: "organisations" } & Pick<
              Types.Organisations,
              "name" | "id"
            >;
          }
        >;
      }
  >;
};

export const GetBanksDocument = gql`
  query GetBanks {
    banks(order_by: { name: asc }) {
      notes
      id
      name
      address
      regulator
      ownership
      created_at
      risk_rating_sp_date
      risk_rating_short_sp
      risk_rating_long_sp
      risk_outlook_sp
      risk_rating_fitch_date
      risk_rating_short_fitch
      risk_rating_long_fitch
      risk_outlook_fitch
      risk_rating_moodys_date
      risk_rating_long_moodys
      risk_outlook_moodys
      risk_5y_cds_spread
      risk_total_equity
      risk_cet_capital_ratio
      risk_leverage_ratio
      risk_liquidity_coverage_ratio
      risk_share_movement
      risk_market_cap
      risk_base_currency
      image {
        s3_key
        s3_level
        public_url
      }
      bank_factsheets {
        factsheetDate
        upload {
          reviewed
          description
          created_at
          public_url
          id
        }
      }
      organisations {
        organisation {
          name
          id
        }
      }
    }
  }
`;

export function useGetBanksQuery(
  options: Omit<Urql.UseQueryArgs<GetBanksQueryVariables>, "query"> = {}
) {
  return Urql.useQuery<GetBanksQuery>({ query: GetBanksDocument, ...options });
}
